module.exports = __webpack_public_path__ + "img/orderAmount.3902d1f4.png";